import { NotificationRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNotification: (
  fetchContext: FetchContext,
  notificationId: number,
  notification: NotificationRequest,
  accessToken?: string,
) => Promise<void> = async (fetchContext, notificationId, notification, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/notifications/${notificationId}`,
  {
    method: 'PUT',
    body: JSON.stringify(notification),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update notification'));
